import React, { useCallback } from 'react';

import { Icon, Space } from '@sravni/react-design-system';
import { Link, Text } from '@sravni/react-design-system/lib/Typography';
import { ArrowRight } from '@sravni/react-icons';
import { RegionDialog } from '@sravni/react-region-dialog';
import { useBoolean, useStyles } from '@sravni/react-utils';
import type { ILocationV2 } from '@sravni/types/lib/locations';

import { FILTERS_NAME } from '../../../../../constants/filters';
import { sendChangeLocationEvent } from '../../../../../helpers/analyticsEvents';
import { useFilters } from '../../../../../store/hooks/filters';
import { makeFiltersLink } from '../../../../../utils/routing';

import styles from './select-city.module.scss';

export const SelectCity = () => {
  const cx = useStyles(styles);
  const filters = useFilters();

  const [isVisible, setVisibility] = useBoolean(false);

  const handleChange = useCallback(
    (newLocation: ILocationV2) => {
      sendChangeLocationEvent(newLocation.name);
      const newFilter = {
        ...filters,
        [FILTERS_NAME.Location]: newLocation,
      };

      const link = makeFiltersLink(newFilter);
      document.location.href = link;

      setVisibility.off();
    },
    [filters, setVisibility],
  );

  const onRegionDialogClose = () => {
    setVisibility.off();
  };

  return (
    <>
      <Link onClick={setVisibility.on} className={cx('link')}>
        <Space direction="horizontal" size={2} className="h-color-D60">
          <Text size={14} strong>
            {filters[FILTERS_NAME.Location] ? 'Изменить город' : 'Выбрать город'}
          </Text>
          <Icon size={20} icon={<ArrowRight />} />
        </Space>
      </Link>

      <RegionDialog title="Выберите город" visible={isVisible} onChange={handleChange} onClose={onRegionDialogClose} />
    </>
  );
};

SelectCity.displayName = 'SelectCity';
